import React from "react";

function ProfileModal({ user, onClose, onLogout }) {
  if (!user) return null;

  return (
    <div className="auth-overlay">
      <div className="profile-card">
        <button className="auth-close" onClick={onClose}>
          ×
        </button>

        <div className="profile-avatar">
          {user.firstName?.charAt(0)}
          {user.lastName?.charAt(0)}
        </div>

        <h2>پروفایل کاربری</h2>

        <div className="profile-info">
          <div>
            <span>نام:</span>
            <strong>{user.firstName}</strong>
          </div>

          <div>
            <span>نام خانوادگی:</span>
            <strong>{user.lastName}</strong>
          </div>

          <div>
            <span>شماره موبایل:</span>
            <strong>{user.mobile}</strong>
          </div>

          <div>
            <span>ایمیل:</span>
            <strong>{user.email}</strong>
          </div>

          <div>
            <span>نام کاربری:</span>
            <strong>{user.username}</strong>
          </div>
        </div>

        <button className="logout-btn" onClick={onLogout}>
          خروج از حساب
        </button>
      </div>
    </div>
  );
}

export default ProfileModal;